import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
//import { preset } from 'vue-cli-plugin-vuetify-preset-reply/preset'
const siteconfig = require('@/support/siteconfig')
Vue.use(Vuetify);


export default new Vuetify({
    theme: {
        dark: siteconfig.dark,
        themes: siteconfig.themes,
    },
});
